import axios from "axios";

//state

export var generalState = {
  localidades: [],
  countries: [],
  geo: [],
  interests: [],
  behaviors: [],
  states: [],
  cities: [],
  devices: [],
  campaignObjetives: [],
  billingEvents: [],
  optimizationGoal: [],
  user_accounts: [],
  apps: [],
  status_general: "",
  apache_pages: [],
  publisherplatform: [],
  devicetypes: [],
  adsetposition: [],
  userdeviceOS: [],
  calltoaction: [],
  navs: [
    {
      _name: "CSidebarNav",
      _children: [
        // {
        //   _name: 'CSidebarNavTitle',
        //   _children: ['Settings']
        // },
        {
          _name: "CSidebarNavItem",
          name: "Welcome",
          to: "/welcome",
          icon: "cilLink",
        },
        // {
        //   _name: 'CSidebarNavItem',
        //   name: "Categories",
        //   to: "/blank",
        //   icon: "cil-layers",
        // },
        // {
        //   _name: 'CSidebarNavItem',
        //   name: "Settings",
        //   to: "/home",
        //   icon: "cil-cursor",

        // }
      ],
    },
  ],
  os: [],
  positions: [],
  platform: [],
  api_token_facebook: "",
  boton_action_response: {},
};

var user_context = JSON.parse(localStorage.getItem("user_context"));
var uid = localStorage.getItem("uid");
var pass = localStorage.getItem("pass");

//getters
export var generalGetters = {
  //funciones para optener informacion del state
  getLocalidad: (state) => state.localidades,
  getCountries: (state) => state.countries,
  getapachePages: (state) => state.apache_pages,
  getGeo: (state) => state.geo,
  getInterests: (state) => state.interests,
  getBehaviors: (state) => state.behaviors,
  getCampaignObjetives: (state) => state.campaignObjetives,
  getBillingEvents: (state) => state.billingEvents,
  getOptimizationGoal: (state) => state.optimizationGoal,
  getStates: (state) => state.states,
  getCities: (state) => state.cities,
  getDevices: (state) => state.devices,
  getApiTokenFacebook: (state) => state.api_token_facebook,
  getUserAccounts: (state) => state.user_accounts,
  getApps: (state) => state.apps,
  getNavs: (state) => state.navs,
  getOs: (state) => state.os,
  getPlatform: (state) => state.platform,
  getPositions: (state) => state.positions,
  getBotonActionResponse: (state) => state.boton_action_response,
  getpublisherPlatform: (state) => state.publisherplatform,
  getadsetPosition: (state) => state.adsetposition,
  getuserDeviceOS: (state) => state.userdeviceOS,
  getcalltoAction: (state) => state.calltoaction,
};
//actions
export var generalActions = {
  async getapachePages({ commit }) {
    //,partner_id
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.page', 'search_read', [], ["id", "name"],0,0,""]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var pages_data = res.data.result;
        var pages = [];
        if (res.data.result.length > 0) {
          pages = res.data.result;
        }
        //console.log("apache pages ::: ", res.data.result, pages);
        commit("general_success_pages", pages);
        return res.data.result;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getCountries({ commit }) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'res.country', 'search_read', [], ["id", "name", "code"],
            0,
            0,
            ""
        ]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var country_data = res.data.result;
        var countries = [];
        if (res.data.result.length > 0) {
          countries = res.data.result;
        }
        ////console.log("contries ::: ", res.data.result, countries);
        commit("general_success_countries", countries);
        return res.data.result;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getLocalidad({commit}){
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'brand_whisper.location', 'search_read', [], ["locationName","description","comunidad_autonoma"],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("Prueba de respuesta",res)
        var localidades = [];
        // var states = res.data;
        if (res.data.result.length > 0) {
          localidades = res.data.result;
        }
        //console.log("Prueba de LOCALIDADES",localidades)
        commit("general_success_localidades", localidades);
        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getStateCountry({ commit }, country_id) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context,
        model: "res.country.state",
        domain: [["country_id", "=", country_id]],
        fields: [], //(Fields you need)
        sort: "",
        limit: 0,
      },
    };

    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        var states = [];
        // var states = res.data;
        if (res.data.result.length > 0) {
          states = res.data.result;
        }
        commit("general_success_state", states);
        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getcalltoAction({ commit }, country_id) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.ad.calltoaction', 'search_read', [], ["id", "name"],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var calltoaction = [];
        // var states = res.data;
        if (res.data.result.length > 0) {
          calltoaction = res.data.result;
        }
        commit("general_success_calltoaction", calltoaction);
        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getCityState({ commit }, state_id) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        context: user_context.user_context,
        model: "res.city",
        domain: [["state_id", "=", state_id]],
        fields: [], //(Fields you need)
        sort: "",
        limit: 0,
      },
    };
    await this._vm.$http
      .post("/web/dataset/search_read", req_data)
      .then((res) => {
        var cities = [];
        //console.log("res.data city::: ", res.data);
        res.data.result.map((city) => {
          if (city.state_id[0] == state_id) {
            cities.push(city);
          }
        });
        commit("general_success_city", cities);
        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getUserAccounts({ commit }) {
    //,partner_ids
    commit("general_request");
    // var partner_id = partner_ids;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.user.account', 'search_read', [], [],0,0,""]
      },
    };
    //console.log("payload in user_accounts :::: ", req_data);

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var user_accounts = [];
        if (res.data.result.length > 0) {
          user_accounts = res.data.result;
        }
        commit("general_success_user_account", user_accounts);
        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getpublisherPlatform({ commit }) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.adset.publisherplatform', 'search_read', [], [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var publisherplatform = [];
        if (res.data.result.length > 0) {
          publisherplatform = res.data.result;
        }
        commit("general_success_publisherplatform", publisherplatform);

        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getadsetPosition({ commit }) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.adset.position', 'search_read', [], [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var adsetposition = [];
        if (res.data.result.length > 0) {
          adsetposition = res.data.result;
        }

        commit("general_success_adsetposition", adsetposition);
        //console.log("res in adsetposition", res.data, adsetposition);

        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getDevices({ commit }) {
    commit("general_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.adset.deviceplatform', 'search_read', [], [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var devicetypes = [];
        if (res.data.result.length > 0) {
          devicetypes = res.data.result;
        }
        commit("general_success_devices", devicetypes);

        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getuserDeviceOS({ commit }) {
    commit("general_request");

    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.adset.useros', 'search_read', [], [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var userdeviceOS = [];
        if (res.data.result.length > 0) {
          userdeviceOS = res.data.result;
        }
        commit("general_success_userdeviceOS", userdeviceOS);
        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getDevices12({ commit }) {
    commit("general_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.adset.deviceplatform", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields: "['name', 'id']",
        },
      })
      .then((res) => {
        commit("general_success_devices", res.data);
        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async changeNavs({ commit, state }, opcion) {
    var navs = state.navs;
    navs = [];
    var new_navs = [];
    if (opcion == "quiz") {
      new_navs = [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavDivider",
              _class: "m-2",
            },
            {
              _name: "CSidebarNavItem",
              name: "Websites",
              // to: "/web-sites",
              to: "/blank",
              icon: "cil-cursor",
            },
            {
              _name: "CSidebarNavTitle",
              _children: ["Quiz control"],
            },
            {
              _name: "CSidebarNavItem",
              name: "Surveys",
              // tosurveys: "/quiz-gallery",
              to: "/blank",
              icon: "cil-cursor",
            },
            {
              _name: "CSidebarNavItem",
              name: "Provedor de Internet",
              // to: "/provedor-internet",
              to: "/blank",
              icon: "cil-cursor",
            },
            {
              _name: "CSidebarNavItem",
              name: "ISP",
              // to: "/isp",
              to: "/blank",
              icon: "cil-cursor",
            },
          ],
        },
      ];
    } else if (opcion == "action") {
      new_navs = [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavTitle",
              _children: ["Moderate"],
            },
            // {
            //   _name: "CSidebarNavItem",
            //   name: "Moderate Old",
            //   to: "/Moderate-old",
            //   icon: "cil-cursor",
            // },
            {
              _name: "CSidebarNavItem",
              name: "Moderate",
              to: "/Moderate",
              icon: "cil-cursor",
            },
          ],
        },
      ];
    } else if (opcion == "listen") {
      new_navs = [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavTitle",
              _children: ["Reviews"],
            },
            {
              _name: "CSidebarNavDropdown",
              name: "Surveys",
              icon: "cil-cursor",
              items: [
                {
                  name: "All Surveys",
                  to: "/Surveys",
                },
                {
                  name: "Create",
                  to: "/createquiz",
                },
              ],
            },
            {
              _name: "CSidebarNavDropdown",
              name: "Panel Campaigns",
              icon: "cil-cursor",
              items: [
                {
                  name: "Segmentation Strategies",
                  to: "/segmentationstrategies",
                },
                {
                  name: "Campañas",
                  to: "/campaigns",
                },
              ],
            },
            {
              _name: "CSidebarNavItem",
              name: "Listings",
              to: "/listing",
              icon: "cil-list",
            },
          ],
        },
      ];
    } else if (opcion == "analyze") {
      new_navs = [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavTitle",
              _children: ["Reviews"],
            },
            {
              _name: "CSidebarNavDropdown",
              name: "Google My Business",
              to: "",
              icon: "cil-cursor",
              items: [
                {
                  _name: "CSidebarNavItem",
                  name: "Overview",
                  to: "/dashboard",
                },
                // {
                //   _name: 'CSidebarNavItem',
                //   name: 'Reviews',
                //   to: '/reviews',

                // }
              ],
            },
            {
              _name: "CSidebarNavDropdown",
              name: "Trustpilot",
              to: "",
              icon: "cil-cursor",
              items: [
                {
                  _name: "CSidebarNavItem",
                  name: "Overview",
                  to: "/trustpilotoverview",
                },
                // {
                //   _name: 'CSidebarNavItem',
                //   name: 'Reviews',
                //   to: '/reviews',

                // }
              ],
            },
            {
              _name: "CSidebarNavTitle",
              _children: ["Dimensions"],
            },
            {
              _name: "CSidebarNavItem",
              name: "Insights Retail",
              to: "/insight",
              icon: "cil-cursor",
            },
            {
              _name: "CSidebarNavItem",
              name: "Insights Online",
              to: "/insightonline",
              icon: "cil-cursor",
            },
            {
              _name: "CSidebarNavTitle",
              _children: ["Surveys"],
            },
            {
              _name: "CSidebarNavDropdown",
              name: "Surveys",
              to: "/analyze",
              icon: "cil-cursor",
              items: [
                {
                  _name: "CSidebarNavItem",
                  name: "Overview",
                  to: "/analyze",
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Insights",
                  to: "/insight_analyze",
                },
              ],
            },
          ],
        },
      ];
    } else {
      new_navs = [
        {
          _name: "CSidebarNav",
          _children: [
            {
              _name: "CSidebarNavItem",
              name: "Dashboard",
              to: "/dashboard",
              icon: "cil-speedometer",
            },
            {
              _name: "CSidebarNavTitle",
              _children: ["campaigns"],
            },
            {
              _name: "CSidebarNavItem",
              name: "Campañas",
              to: "/campaigns",
              icon: "fas fa-table",
            },
            {
              _name: "CSidebarNavItem",
              name: "Nueva Campaña",
              to: "/step-by-step",
              icon: "fas fa-plus-circle",
            },
            {
              _name: "CSidebarNavItem",
              name: "Conjunto de anuncios",
              to: "/adsets",
              icon: "fab fa-adversal",
            },
            {
              _name: "CSidebarNavItem",
              name: "Anuncios",
              to: "/ads",
              icon: "fas fa-credit-card",
            },
            {
              _name: "CSidebarNavDivider",
              _class: "m-2",
            },
            {
              _name: "CSidebarNavTitle",
              _children: ["Clientes"],
            },
            {
              _name: "CSidebarNavItem",
              name: "Clientes",
              url: "/partners",
              icon: "fas fa-user-tie",
            },
            {
              _name: "CSidebarNavItem",
              name: "Acciones Estratégicas",
              url: "/acciones-estrategicas",
              icon: "fas fa-chess",
            },
            {
              _name: "CSidebarNavItem",
              name: "Promociones",
              url: "/promociones",
              icon: "fas fa-boxes",
            },
            {
              _name: "CSidebarNavItem",
              name: "Líneas de Contenido",
              url: "/lineas-contenido",
              icon: "fas fa-list-ul",
            },
            {
              _name: "CSidebarNavItem",
              name: "Propuestas",
              url: "/propuestas",
              icon: "far fa-hand-point-up",
            },
            {
              _name: "CSidebarNavItem",
              name: "Geográficos",
              url: "/ideologias",
              icon: "fas fa-fingerprint",
            },
            {
              _name: "CSidebarNavItem",
              name: "Provincias",
              url: "/provincias",
              icon: "fas fa-store-alt",
            },
            {
              _name: "CSidebarNavItem",
              name: "Cód. Postales",
              url: "/cod-postales",
              icon: "fas fa-map-marker-alt",
            },
            {
              _name: "CSidebarNavItem",
              name: "Estereotipos",
              url: "/estereotipos",
              icon: "fas fa-street-view",
            },
            {
              _name: "CSidebarNavItem",
              name: "Audiencias",
              url: "/audiencias",
              icon: "fas fa-child",
            },
            {
              _name: "CSidebarNavDivider",
              _class: "m-2",
            },
            {
              _name: "CSidebarNavTitle",
              _children: ["Facebook"],
            },

            {
              _name: "CSidebarNavItem",
              name: "Cuentas Ads",
              url: "/ads-accounts",
              icon: "fas fa-ad",
            },
            {
              _name: "CSidebarNavItem",
              name: "Páginas",
              url: "/pages",
              icon: "fas fa-address-card",
            },
            {
              _name: "CSidebarNavItem",
              name: "Pixels",
              url: "/pixels",
              icon: "fas fas fa-chart-pie",
            },
            {
              _name: "CSidebarNavItem",
              name: "Business Account",
              url: "/business",
              icon: "fas fa-briefcase",
            },
          ],
        },
      ];
    }
    navs.push(...new_navs);
    commit("general_success_navs", navs);
  },
  async getOs({ commit }) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.adset.useros', 'search_read', [], ["id", "name", "platform"],0,0,""]
      },
    };
    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        //console.log("general_success_os", res.data);
        var user_os = [];
        if (res.data.result.length > 0) {
          user_os = res.data.result;
        }
        commit("general_success_os", user_os);
        return res.data.result;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },

  async getPlatform({ commit }) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.adset.publisherplatform', 'search_read', [], [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var publisherplatform = [];
        if (res.data.result.length > 0) {
          publisherplatform = res.data.result;
        }
        commit("general_success_platform", publisherplatform);

        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getPositions({ commit }) {
    commit("general_request");
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.adset.position', 'search_read', [], [],0,0,""]
      },
    };

    await this._vm.$http
      .post("/jsonrpc", req_data)
      .then((res) => {
        var adsetposition = [];
        if (res.data.result.length > 0) {
          adsetposition = res.data.result;
        }

        commit("general_success_position", adsetposition);
        //console.log("res in adsetposition", res.data, adsetposition);

        return res.data;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  },
  async getBotonActionResponse({ commit }, params) {
    var { model, method, id } = params;
    var req_data = {
      jsonrpc: "2.0",
      method: "call",
      params: {
        service: 'object',
        method: 'execute',
        args: [axios.defaults.db, uid, pass, 'apache.quiz', 'quiz_preview', [id] ]
      },
    };
    await this._vm.$http
      .post("jsonrpc", req_data)
      .then((res) => {
        ////console.log(res.data.result);
        // if (res.data.success == true) {
        // }
        var preview = "";
        // if(res.data.result > 0){
        preview = res.data.result;
        // }
        commit("general_success_boton_action", preview);
        return preview;
      })
      .catch((err) => {
        commit("general_error");
        return err;
      });
  }
};

//mutations

export var generalMutations = {
  general_success_localidades(state, payload){
    state.status_general = "success";
    state.localidades = payload;
  },
  general_request(state) {
    state.status_general = "loading";
  },
  general_success_navs(state, payload) {
    state.status_general = "success";
    state.navs = payload;
  },
  general_success_countries(state, payload) {
    state.status_general = "success";
    state.countries = payload;
  },
  general_success_state(state, payload) {
    state.status_general = "success";
    state.states = payload;
  },
  general_success_city(state, payload) {
    state.status_general = "success";
    state.cities = payload;
  },
  general_success_geo(state, payload) {
    state.status_general = "success";
    state.geo = payload;
  },
  general_success_devices(state, payload) {
    state.status_general = "success";
    //console.log("devices payload", payload);
    state.devices = payload;
  },
  general_success_userdeviceOS(state, payload) {
    state.status_general = "success";
    //console.log("devices payload", payload);
    state.userdeviceOS = payload;
  },
  general_success_boton_action(state, payload) {
    state.status_general = "success";
    state.boton_action_response = payload;
  },
  general_success_interest(state, payload) {
    state.status_general = "success";
    state.interests = payload;
  },
  general_success_behaviors(state, payload) {
    state.status_general = "success";
    state.behaviors = payload;
  },
  general_success_campaignObjetives(state, payload) {
    state.status_general = "success";
    state.campaignObjetives = payload;
  },
  general_success_billingEvent(state, payload) {
    state.status_general = "success";
    state.billingEvents = payload;
  },
  general_success_optimizationGoal(state, payload) {
    state.status_general = "success";
    state.optimizationGoal = payload;
  },
  general_success_token(state, payload) {
    state.status_general = "success";
    state.api_token_facebook = payload;
  },
  general_success_step_by_step(state, payload = {}) {
    state.status_general = "success";
    state.optimizationGoal = payload;
  },
  general_success_user_account(state, payload) {
    state.status_general = "success";
    state.user_accounts = payload;
  },
  general_success_app(state, payload) {
    state.status_general = "success";
    state.apps = payload;
  },
  general_success_os(state, payload) {
    state.status_general = "success";
    state.os = payload;
  },
  general_success_calltoaction(state, payload) {
    state.status_general = "success";
    state.calltoaction = payload;
  },
  general_success_platform(state, payload) {
    state.status_general = "success";
    state.platform = payload;
  },
  general_success_adsetposition(state, payload) {
    state.status_general = "success";

    state.adsetposition = payload;
  },
  general_success_publisherplatform(state, payload) {
    state.status_general = "success";
    state.publisherplatform = payload;
  },
  general_success_position(state, payload) {
    state.status_general = "success";
    state.positions = payload;
  },
  general_success_pages(state, payload) {
    state.status_general = "success";
    state.apache_pages = payload;
  },
  general_error(state) {
    state.status_general = "error";
  },
};
